import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	viewBox: "0 0 512 512",
	width: "20px",
	height: "20px",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd"
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: { opacity: .994 },
			fill: "#fefffe",
			d: "M 125.5,-0.5 C 212.167,-0.5 298.833,-0.5 385.5,-0.5C 397.31,6.09644 400.476,15.7631 395,28.5C 392.548,31.8207 389.382,34.3207 385.5,36C 298.833,36.6667 212.167,36.6667 125.5,36C 113.593,29.6142 110.427,20.1142 116,7.5C 118.695,4.24126 121.861,1.57459 125.5,-0.5 Z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: { opacity: .972 },
			fill: "#fefffe",
			d: "M 99.5,66.5 C 203.501,66.3333 307.501,66.5 411.5,67C 424.889,69.7392 430.389,77.9059 428,91.5C 425.833,97.6667 421.667,101.833 415.5,104C 308.833,104.667 202.167,104.667 95.5,104C 84.8753,99.6859 80.7087,91.8526 83,80.5C 85.8894,72.6538 91.3894,67.9871 99.5,66.5 Z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: { opacity: .994 },
			fill: "#fefffe",
			d: "M 420.5,511.5 C 310.5,511.5 200.5,511.5 90.5,511.5C 65.6249,505.456 50.7916,489.789 46,464.5C 45.3333,370.167 45.3333,275.833 46,181.5C 51.8224,154.679 68.3224,139.179 95.5,135C 202.167,134.333 308.833,134.333 415.5,135C 442.678,139.179 459.178,154.679 465,181.5C 465.667,275.833 465.667,370.167 465,464.5C 460.208,489.789 445.375,505.456 420.5,511.5 Z M 180.5,220.5 C 190.021,218.944 197.187,222.278 202,230.5C 203.439,242.758 203.939,255.091 203.5,267.5C 238.167,267.5 272.833,267.5 307.5,267.5C 307.333,256.162 307.5,244.828 308,233.5C 314.076,220.363 323.576,217.197 336.5,224C 340.382,227.264 342.549,231.43 343,236.5C 343.667,253.5 343.667,270.5 343,287.5C 341.046,296.455 335.546,301.621 326.5,303C 277.463,303.976 228.463,303.643 179.5,302C 174.667,299.833 171.167,296.333 169,291.5C 167.886,281.723 167.386,271.89 167.5,262C 167.399,251.786 167.899,241.619 169,231.5C 171.412,226.252 175.246,222.586 180.5,220.5 Z"
		}) })
	]
});
export default SvgArchive;
